import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { InputGroup as InputGroupCore } from '@mc/react-core';
import { Field } from '../Field';
import { FormItem } from './FormItem';
import { Switch as BaseSwitch } from '@mc/react-core';
import { MFieldProps } from '../types';

export type StringProps = MFieldProps<
  React.ComponentProps<typeof InputGroupCore>
>;
export const Switch = React.forwardRef<HTMLInputElement, StringProps>(
  (
    {
      name,
      validate,
      className,
      inputClassName,
      onChange: customOnChange,
      disabled,
      required,
      ...other
    },
    ref
  ) => {
    return (
      <FormItem
        name={name}
        className={className}
        required={required}
        disabled={disabled}
      >
        <Field name={name} validate={validate} type={'checkbox'}>
          {({
            input: { checked, name, ...nother },
          }: //form: { setFieldValue },
          FieldRenderProps<string>) => {
            return (
              <BaseSwitch
                className={inputClassName}
                // @ts-ignore
                ref={ref}
                {...nother}
                name={name}
                {...other}
                disabled={disabled}
                checked={checked}
              />
            );
          }}
        </Field>
      </FormItem>
    );
  }
);
